// ============================================================================
//  Programa: EOP
//  Encuesta: "fin" (form 5176375).
//  Incluye un campo en cascada Departamento → Localidad (ver eopLocalidades.js).
// ============================================================================
import EOP_LOCALIDADES from "./eopLocalidades";
import { validarCedula, validarEmail, validarFecha } from "./validaciones";

const DEFAULTS_EOP = {};

const NOTA_1_10 = (base) =>
  Array.from({ length: 10 }, (_, i) => ({
    val: `tfa_${base + (9 - i)}`,
    label: String(10 - i),
  }));
const STEPS_EOP = [
  { id: "tfa_1877", label: "¡Hola! Para empezar, ¿cuál es tu nombre?", type: "text", placeholder: "Tu nombre" },
  { id: "tfa_1875", label: "¿Y tu apellido?", type: "text", placeholder: "Tu apellido" },
  { id: "tfa_1", label: "¿Cuál es tu cédula de identidad?", type: "text", placeholder: "Tu número de documento", validate: validarCedula },
  { id: "tfa_1879", label: "¿Con qué género te identificás?", type: "radio", options: [
    { val: "tfa_1966", label: "Masculino" },
    { val: "tfa_1967", label: "Femenino" },
    { val: "tfa_1968", label: "No binario" },
  ]},
  { id: "tfa_1881", label: "¿Cuál es tu fecha de nacimiento? (DD/MM/AAAA)", type: "text", placeholder: "Ej: 15/06/2001", validate: validarFecha },
  { id: "tfa_3", label: "¿Cuál es tu correo electrónico personal?", type: "text", placeholder: "tu@email.com", validate: validarEmail },
  { id: "tfa_1885", label: "¿Cuál es tu número de celular?", type: "text", placeholder: "Ej: 099123456" },

  // Campo en cascada: departamento -> localidad
  {
    id: "tfa_1998", // departamento (campo principal)
    label: "¿En qué departamento vivís?",
    type: "cascade",
    cascade: EOP_LOCALIDADES, // { depField, departamentos: [{val,label,locField,localidades:[...]}] }
    childLabel: "¿Y en qué localidad?",
  },

  { id: "tfa_4680", label: "Siendo 1 muy poco satisfactorio y 10 muy satisfactorio, ¿cómo evaluarías a las talleristas?", type: "radio", options: NOTA_1_10(4681) },
  { id: "tfa_4702", label: "Siendo 1 muy poco satisfactorio y 10 muy satisfactorio, ¿qué te parecieron los contenidos trabajados en los talleres?", type: "radio", options: NOTA_1_10(4703) },
  { id: "tfa_4736", label: "Siendo 1 no recomiendo y 10 recomiendo totalmente, ¿cuánto recomendarías el programa a un amigo?", type: "radio", options: NOTA_1_10(4737) },
  { id: "tfa_4724", label: "¿Y qué te gustaría cambiar?", type: "text", placeholder: "Contanos con tus palabras..." },
  { id: "tfa_4748", label: "Al inscribirte a este evento, ¿autorizás a DESEM JA a usar las imágenes en las que aparezcas en sus sitios web, redes sociales o piezas de comunicación institucionales con fines publicitarios e informativos?", type: "radio", options: [
    { val: "tfa_4749", label: "Sí" },
    { val: "tfa_4750", label: "No" },
  ]},
];

const eop = {
  label: "EOP",
  tipoPorDefecto: "fin",
  tipos: {
    fin: {
      formId: "5176375",
      titulo: "Evaluación",
      subtitulo: "Encuesta de fin de programa",
      saludo: "¡Hola! Voy a ayudarte a completar la encuesta de fin de programa. ¡Empecemos!",
      cierre: "¡Perfecto! Respondiste todas las preguntas.",
      exito: "Gracias por completar la encuesta y por haber participado del programa. ¡Felicitaciones!",
      defaults: DEFAULTS_EOP,
      steps: STEPS_EOP,
    },
  },
};

export default eop;